// extracted by mini-css-extract-plugin
export default {"setting-property-btn":"SpaceModal_setting-property-btn__Zxq4u"};